import { useSdkBuildInfo } from '../../../features/hostingVersions/hooks/useSdkBuildInfo'

export const useDeployedHostingVersion = () => {
  return useSdkBuildInfo()?.deployedVersion
}
